import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import CardResult from './components/CardResult';
import TeamDateCards from './components/TeamDateUserCards';
import CertificateId from './components/CertificateId';
import ResultAnalysis from './components/ResultAnalysis';
import Share from './components/Share';
import Gallery from './components/Gallery';
import Disclaimer from './components/Disclaimer';
// eslint-disable-next-line no-unused-vars
import ModelCheck from './model/ModelCheck';
import ResultExplanation from './components/ResultExplanation';
import DialogShare from './components/DialogShare';
import Apis from './api/Apis';
import ErrorPage from './ErrorPage';
//
import IMG_appstore from "./assets/images/appstore.png"
import IMG_playstore from "./assets/images/playstore.png"

const App = () => {
    const isMobile = window.innerWidth < 768
    /**
     * @type {ModelCheck}
     */
    const [showDialog, setshowDialog] = useState(false)
    const [check, setCheck] = useState(null)
    const [loading, setloading] = useState(true)
    const [isError, setisError] = useState(false)
    useEffect(() => { fetchData() }, [])
    
    async function fetchData() {
        try {
            let url = window.location.href
            let certif = url.split("check/")[1]
            let data = await Apis.fetchData(certif)
            console.log(data);
            setCheck(data)
        } catch (error) {
            setisError(true)
        }
        setloading(false)
    }


    return (
        <>
            {
                loading 
                ? <div className='loading'></div>
                : isError
                ? <ErrorPage/>
                : <div>
                    <Header data={check}/>
                    <div className='layout'>
                        <div>
                            <CardResult data={check}/>
                            <ResultExplanation data={check}/>
                            <TeamDateCards data={check}/>
                            <CertificateId data={check}/>
                            {
                                isMobile && <Share data={check} onClickShare={() => {setshowDialog(true)}}/>
                            }
                            {
                                isMobile && <hr/>
                            }
                            {
                                isMobile && <Gallery data={check}/>
                            }

                            <ResultAnalysis data={check}/>

                            {
                                !isMobile && 
                                <div style={{ display: "flex", gap: 10, justifyContent: "end" }}>
                                    <a href="https://play.google.com/store/apps/details?id=com.app.kitlegit&hl=pt_BR">
                                        <img src={IMG_playstore} alt="" style={{height: 40, cursor: "pointer"}}/>
                                    </a>
                                    <a href="https://apps.apple.com/hr/app/kitlegit/id6459883332">
                                        <img src={IMG_appstore} alt="" style={{height: 40, cursor: "pointer"}}/>
                                    </a>
                                    <Share data={check} onClickShare={() => {setshowDialog(true)}}/>
                                </div>
                            }
                            
                            {
                                isMobile && 
                                
                                <div>
                                    <Share data={check} onClickShare={() => {setshowDialog(true)}}/>

                                    <p style={{textAlign: "center", margin: 0, marginTop: 40, marginBottom: 10}}>Get the app now</p>
                                    <div style={{ display: "flex", gap: 10, justifyContent: "center",  }}>
                                        <a href="https://play.google.com/store/apps/details?id=com.app.kitlegit&hl=pt_BR">
                                            <img src={IMG_playstore} alt="" style={{height: 40, cursor: "pointer"}}/>
                                        </a>
                                        <a href="https://apps.apple.com/hr/app/kitlegit/id6459883332">
                                            <img src={IMG_appstore} alt="" style={{height: 40, cursor: "pointer"}}/>
                                        </a>
                                    </div>
                                </div>
                            }
                            
                            
                        </div>

                        {
                            !isMobile && <div><Gallery data={check}/></div>
                        }
                        
                    </div>
                    <hr/>
                    <Disclaimer data={check}/>     


                    {/* dialog     */}
                    {
                        showDialog && <DialogShare data={check} onClose={() => {setshowDialog(false)}} />
                    }


                </div>
            }
        </>
    )
}

export default App